import React, { useState, useEffect } from "react";

import { Link, useLocation } from "react-router-dom";

import MainHeader from "./MainHeader";
import NavLinks from "./NavLinks";
import Backdrop from "../UIElements/BackDrop.js"


import logo from '../../images/logo/cropped-Combat-Sports-Luebeck_Logo2018.png'

import './MainNavigation.css';
import SideDrawer from "./SideDrawer";

const MainNavigation = function (props) {

    const [drawerIsOpen, setDrawerIsOpen] = useState(false);
    const [transNav, setTransNav] = useState(0);
    // const [scrollPosition, setScrollPosition] = useState(0);



    const closeDrawerHandler = () => {
        setDrawerIsOpen(false);
    }

    const toggleDrawerHandler = () => {
        setDrawerIsOpen(!drawerIsOpen);
    }





    const mainHeaderStyle = {

        background: `rgba(22, 22, 22, ${transNav})`,
        transition: `background 0.5s ease-in-out`,


    };

    const mainHeaderLogoStyle = {

        opacity: transNav,
        transition: `opacity 0.5s ease-in-out`,

    };

    let location = useLocation();


    useEffect(() => {
        const handleResize = () => {

            if (window.innerWidth >= 850) {
                setDrawerIsOpen(false);
            }

        }
        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        }

    }, [])

    useEffect(() => {
        if (location.pathname === "/") {
            setTransNav(0);
            const handleScroll = () => {
                const position = window.pageYOffset;
                const height = window.innerHeight;
                if (position >= height - 85 - height * 0.1) {
                    setTransNav(1);
                } else {
                    setTransNav(0);
                }

            }

            window.addEventListener("scroll", handleScroll);

            return () => {
                window.removeEventListener("scroll", handleScroll);
            }
        } else {
            setTransNav(1);
        }


    }, [location.pathname]);


    return (
        <React.Fragment>
            {drawerIsOpen && <Backdrop onClick={closeDrawerHandler} />}
            <SideDrawer show={drawerIsOpen} onClick={closeDrawerHandler}>
                <nav className="main-navigation__drawer-nav">
                    <NavLinks />
                </nav>
            </SideDrawer>
            <MainHeader style={mainHeaderStyle}>
                <button className="main-navigation__menu-btn" onClick={toggleDrawerHandler}>
                    <span />
                    <span />
                    <span />
                </button>
                <h1 className="main-navigation__title">
                    <Link to="/" className="main-navigation__title">
                        <img src={logo} className="main-navigation__logo" style={mainHeaderLogoStyle} alt="logo" />
                    </Link>
                </h1>
                <nav className="main-navigation__header-nav">
                    <NavLinks />
                </nav>
            </MainHeader>
        </React.Fragment>
    )
};

export default MainNavigation;